module.exports = __webpack_public_path__ + "media/images/front/sp/article/thum05-a7737742a06ffaf311b068d42b8b9af0.png";